const state = {
	limitStatisticData: {
		items: [],
		total: 0
	}
}

export default state
